import { css, styled } from 'styled-components'
import { COLORS } from 'consts/colors'

export const dropdownItemStyles = css`
  width: 100%;
  transition: background 0.2s;
  cursor: pointer;
  &:hover {
    background: ${COLORS.primaryLight};
  }

  &:active {
    background: ${COLORS.secondaryLight};
  }
`

const listItemStyles = css`
  height: 100%;
  display: flex;
  align-items: center;
  padding: 12px 15px;
  text-decoration: none;
`

export const ListItemWrapper = styled.li`
  ${dropdownItemStyles};
  display: flex;
  align-items: center;
`

export const ListItemLink = styled.a`
  ${listItemStyles};
`

export const ListItem = styled.div`
  ${listItemStyles};
`

export const Label = styled.span`
  color: ${COLORS.secondarySemiDark};
  font-size: 14px;
  font-weight: 500;
  margin-left: 8px;
`

export const IconWrapper = styled.div<{ $iconBgColor?: string }>`
    width: 24px;
    height: 24px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      width: 12px;
      height: 12px;
    }


    ${({ $iconBgColor }) =>
      $iconBgColor
        ? css`
            background: ${$iconBgColor};

            & > svg {
              fill: ${COLORS.white};
            }
          `
        : css`
            background-color: #545f7e33;

            & > svg {
              fill: ${COLORS.secondarySemiDark};
            }
          `})
}
`

export const ArrowDownWrapper = styled.div<{ $isExpanded: boolean }>`
  width: 8px;
  height: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-inline-start: 8px;
  transition: transform 0.2s;
  transform: rotate(${({ $isExpanded }) => ($isExpanded ? '-180deg' : '0deg')});
  svg {
    width: 100%;
    height: 100%;
  }
`
